import React, { useState } from "react";
import UserProfileCompletionStageDialog from "./userProfileCompletionStageDialog";
import UserProfileCompletionIndicator from "./userProfileCompletionIndicator";

const UserProfileCompletionNavBarButton = () => {
  const [showStageDialog, setShowStageDialog] = useState(undefined);

  return (
    <>
      <div
        className="hidden h-[40px] items-center gap-2 px-6 lg:flex"
        role="button"
        onClick={() => setShowStageDialog(true)}
      >
        <UserProfileCompletionIndicator isCondensed radius={10} />
      </div>
      <UserProfileCompletionStageDialog
        open={showStageDialog}
        onCancel={() => setShowStageDialog(false)}
      />
    </>
  );
};

export default UserProfileCompletionNavBarButton;
